//Modulos varios
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Proteger las rutas
import { MyGuard } from '../services/my-guard.service';
import {CanActivate} from "@angular/router";

//Componentes
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { PaymentComponent } from './payment/payment.component';
import { Error1Component } from './Errores/error1/error1.component';
import { Error2Component } from './Errores/error2/error2.component';
import { Error3Component } from './Errores/error3/error3.component';
import { Error4Component } from './Errores/error4/error4.component';
import { CygwinNotepadComponent } from './Instalaciones/cygwin-notepad/cygwin-notepad.component';
import { BashProfileComponent } from './Utilidades/bash-profile/bash-profile.component';
import { InstallComponent } from './Instalaciones/install/install.component';
import { FirestoreComponent } from './Instalaciones/firestore/firestore.component';
import { JqueryComponent } from './Instalaciones/jquery/jquery.component';
import { BuildComponent } from './Instalaciones/build/build.component';
import { GoogleCloudPlatformComponent } from './Utilidades/google-cloud-platform/google-cloud-platform.component';
import { InstallPluginsComponent } from './Consejos/install-plugins/install-plugins.component';
import { ComandosComponent } from './Consejos/comandos/comandos.component';
import { IonloadLeaveComponent } from './Consejos/ionload-leave/ionload-leave.component';
import { ConsultasComponent } from './Consejos/consultas/consultas.component';
import { ContadoresComponent } from './Consejos/contadores/contadores.component';
import { CrearServicioComponent } from './Consejos/crear-servicio/crear-servicio.component';
import { JsonLineasComponent } from './Utilidades/json-lineas/json-lineas.component';
import { FormulariosComponent } from './Utilidades/formularios/formularios.component';
import { TimerComponent } from './Utilidades/timer/timer.component';
import { ParametrosComponent } from './Utilidades/parametros/parametros.component';
import { StorageIonicComponent } from './Utilidades/storage-ionic/storage-ionic.component';
import { TraduccionesComponent } from './Utilidades/traducciones/traducciones.component';
import { IonSelectComponent } from './Utilidades/ion-select/ion-select.component';
import { FotoUrlComponent } from './Utilidades/foto-url/foto-url.component';
import { BorrarColeccionesComponent } from './Utilidades/borrar-colecciones/borrar-colecciones.component';
import { FechasComponent } from './Utilidades/fechas/fechas.component';
import { AnimacionesComponent } from './design/animaciones/animaciones.component';
import { FontsComponent } from './Design/fonts/fonts.component';
import { FotoFondoComponent } from './Design/foto-fondo/foto-fondo.component';
import { ImagenPorDefectoComponent } from './Design/imagen-por-defecto/imagen-por-defecto.component';
import { ComoLlegarComponent } from './Design/como-llegar/como-llegar.component';
import { NotificacionesComponent } from './Practicos/notificaciones/notificaciones.component';
import { ComentariosDestacadosComponent } from './Practicos/comentarios-destacados/comentarios-destacados.component';
import { SubirFotosComponent } from './Practicos/subir-fotos/subir-fotos.component';
import { SubirAudiosComponent } from './Practicos/subir-audios/subir-audios.component';
import { ReproductorComponent } from './Practicos/reproductor/reproductor.component';
import { MapsComponent } from './Practicos/maps/maps.component';
import { LoginRegisComponent } from './Practicos/login-regis/login-regis.component';
import { RecPassComponent } from './Practicos/rec-pass/rec-pass.component';
import { AdmobComponent } from './Plugins/admob/admob.component';
import { StripeComponent } from './Plugins/stripe/stripe.component';
import { ProyectoComponent } from './Practicos/proyecto/proyecto.component';
import { RegistroComponent } from './registro/registro.component';
import { ProyectoDComponent } from './design/proyecto-d/proyecto-d.component';
import { IdiomasComponent } from './idiomas/idiomas.component';

//Configuracion de las rutas
const appRoutes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {path: 'home', component: HomeComponent},
  {path: 'payment', component: PaymentComponent},
  {path: 'error1', component: Error1Component, canActivate:[MyGuard]},
  {path: 'error2', component: Error2Component, canActivate:[MyGuard]},
  {path: 'error3', component: Error3Component, canActivate:[MyGuard]},
  {path: 'error4', component: Error4Component, canActivate:[MyGuard]},
  {path: 'CygwinNotepad', component: CygwinNotepadComponent},
  {path: 'bashProfile', component: BashProfileComponent},
  {path: 'instalacion', component: InstallComponent},
  {path: 'firestore', component: FirestoreComponent},
  {path: 'jQuery', component: JqueryComponent},
  {path: 'build', component: BuildComponent, canActivate:[MyGuard]},
  {path: 'GoogleCloudPlatform', component: GoogleCloudPlatformComponent},
  {path: 'installPlugins', component: InstallPluginsComponent},
  {path: 'comandos', component: ComandosComponent},
  {path: 'Consultas', component: ConsultasComponent, canActivate:[MyGuard]},
  {path: 'Contadores', component: ContadoresComponent, canActivate:[MyGuard]},
  {path: 'CrearServicio', component: CrearServicioComponent},
  {path: 'json', component: JsonLineasComponent},
  {path: 'formularios', component: FormulariosComponent},
  {path: 'timer', component: TimerComponent},
  {path: 'parametros', component: ParametrosComponent},
  {path: 'storage', component: StorageIonicComponent},
  {path: 'traducciones', component: TraduccionesComponent, canActivate:[MyGuard]},
  {path: 'ionSelect', component: IonSelectComponent, canActivate:[MyGuard]},
  {path: 'fotoUrl', component: FotoUrlComponent, canActivate:[MyGuard]},
  {path: 'borrarColecciones', component: BorrarColeccionesComponent},
  {path: 'fechas', component: FechasComponent, canActivate:[MyGuard]},
  {path: 'animaciones', component: AnimacionesComponent},
  {path: 'fonts', component: FontsComponent},
  {path: 'fotoFondo', component: FotoFondoComponent},
  {path: 'imagenPorDefecto', component: ImagenPorDefectoComponent, canActivate:[MyGuard]},
  {path: 'comoLlegar', component: ComoLlegarComponent, canActivate:[MyGuard]},
  {path: 'notificaciones', component: NotificacionesComponent},
  {path: 'comentariosDestacados', component: ComentariosDestacadosComponent, canActivate:[MyGuard]},
  {path: 'SubirFotos', component: SubirFotosComponent, canActivate:[MyGuard]},
  {path: 'SubirAudios', component: SubirAudiosComponent, canActivate:[MyGuard]},
  {path: 'Reproductor', component: ReproductorComponent, canActivate:[MyGuard]},
  {path: 'Maps', component: MapsComponent, canActivate:[MyGuard]},
  {path: 'Login', component: LoginRegisComponent},
  {path: 'RecPass', component: RecPassComponent},
  {path: 'Admob', component: AdmobComponent},
  {path: 'Stripe', component: StripeComponent, canActivate:[MyGuard]},
  {path: 'Proyecto', component: ProyectoComponent},
  {path: 'ionViewDidLoadIonViewDidLeave', component: IonloadLeaveComponent},
  {path: 'Registro', component: RegistroComponent},
  {path: 'DesignP', component: ProyectoDComponent},
  {path: 'idiomas', component: IdiomasComponent},
  {path: '**', component: HomeComponent}
];

export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./src/app/app.routing.ts